import { colors, typography } from '../../../styles/theme';

export const mapStatusBannerBorderColor = '#6DA8A7';

export const mapStatusBannerChromeStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  width: 'max-content',
  minHeight: '45px',
  boxSizing: 'border-box',
  padding: '0 12px 0 10px',
  backgroundColor: colors.backgroundSurface,
  color: colors.textPanelDescription,
  border: `1px solid ${mapStatusBannerBorderColor}`,
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.14)',
};

export const mapStatusBannerContainerStyle = {
  position: 'absolute',
  bottom: '20px',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1000,
  maxWidth: 'min(640px, calc(100vw - 40px))',
  ...mapStatusBannerChromeStyle,
};

export const mapStatusBannerIconStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: '8px',
  color: colors.primary,
  flexShrink: 0,
};

export const mapStatusBannerTextStyle = {
  flex: 1,
  minWidth: 0,
  fontFamily: typography.fontFamily.primary,
  fontSize: '14px',
  fontWeight: typography.fontWeight.regular,
  lineHeight: '14px',
  letterSpacing: typography.letterSpacing.tight,
};

export const mapStatusBannerSpinnerStyle = {
  width: 18,
  height: 18,
  border: '2px solid rgba(255, 255, 255, 0.35)',
  borderTopColor: colors.textPanelDescription,
  borderRadius: '50%',
  display: 'inline-block',
  animation: 'map-loader-spin 0.9s linear infinite',
};

export const mapStatusBannerCloseButtonSx = {
  width: 28,
  height: 28,
  color: 'rgba(255, 255, 255, 0.82)',
  flexShrink: 0,
  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.14)' },
};
